import * as React from 'react'
import { Divider, Grid } from '@mui/material'
import { DataGrid, GridColDef } from '@mui/x-data-grid'
import GridItem from 'src/components/grid-item/GridItem'
import {
    PersionInquiry,
    PersionInquiryReport,
    PersoncheckInquiriesQuantity,
    PersonCreditInquiriesQuantity,
    PersonInquirySummaryReport
} from 'src/modules/serasa/serasa.experian.person.types'
import { formatDateNoTz } from 'src/utils/formatter-utils'

const consultaItemColumns = static_build_consulta_item_columns()
const checkColumns = static_build_check_columns()
const creditColumns = static_build_credit_columns()

export type ConsultasProps = {
    inquiry?: PersionInquiryReport
    summary?: PersonInquirySummaryReport
}

export default function Consultas({ inquiry, summary }: ConsultasProps) {
    if (!inquiry && !summary) {
        return <></>
    }

    return (
        <>
            <Divider textAlign="center">Histórico de Consultas</Divider>

            <GridItem label="Total de Consultas" value={summary?.summary?.count.toFixed(0) || '-'} xs={12} />

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <Grid item xs={12}>
                    <DataGrid
                        rows={inquiry?.inquiryResponse || []}
                        columns={consultaItemColumns}
                        getRowId={static_getConsultaItemRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Divider textAlign="center">Consultas de Cheques</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Consultas" value={summary?.summary.checkCount.toFixed(0) || '-'} xs={12} />

                <Grid item xs={12}>
                    <DataGrid
                        rows={summary?.inquiryQuantity?.checkInquiriesQuantity || []}
                        columns={checkColumns}
                        getRowId={static_getCheckRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>

            <Divider textAlign="center">Consulta de Crédito</Divider>

            <Grid container spacing={1} paddingTop={2} paddingBottom={2} paddingLeft={5} paddingRight={5}>
                <GridItem label="Consultas" value={summary?.summary?.creditCount.toFixed(0) || '-'} xs={12} />

                <Grid item xs={12}>
                    <DataGrid
                        rows={summary?.inquiryQuantity?.creditInquiriesQuantity || []}
                        columns={creditColumns}
                        getRowId={static_getCheckRowId}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 10
                                }
                            }
                        }}
                    />
                </Grid>
            </Grid>
        </>
    )
}

function static_getConsultaItemRowId(row: PersionInquiry) {
    return row.occurrenceDate
}

function static_getCheckRowId(row: PersoncheckInquiriesQuantity | PersonCreditInquiriesQuantity) {
    return row.inquiryDate
}

function static_build_consulta_item_columns(): GridColDef[] {
    return [
        {
            field: 'occurrenceDate',
            headerName: 'Data',
            valueGetter(params) {
                return formatDateNoTz(params.row.occurrenceDate)
            },
            width: 100
        },
        {
            field: 'segmentDescription',
            headerName: 'Segmento',
            width: 200
        },
        {
            field: 'daysQuantity',
            headerName: 'Quantidade',
            width: 100
        }
    ]
}

function static_build_credit_columns(): GridColDef[] {
    return [
        {
            field: 'inquiryDate',
            headerName: 'Mês',
            width: 200
        },
        {
            field: 'occurrences',
            headerName: 'Quantidade',
            width: 100
        },
        {
            field: 'bankOccurrences',
            headerName: 'Consultas Bancárias',
            width: 100
        },
        {
            field: 'companyOccurrences',
            headerName: 'Consultas Comerciais',
            width: 100
        }
    ]
}

function static_build_check_columns(): GridColDef[] {
    return [
        {
            field: 'inquiryDate',
            headerName: 'Mês',
            width: 200
        },
        {
            field: 'occurrences',
            headerName: 'Quantidade',
            width: 100
        }
    ]
}
